import React from "react";
import ChiffresCles from "./components/NosChiffresCles/ChiffresCles";
import BtNext from "./components/BtNext/";

const NosChiffresCles = () => {
    return (
        <section id="nos_chiffres_cles">
            <section id="desfemmes">
                <ChiffresCles />
                <BtNext internal color="black" url="desimmeubles" />
            </section>

            <BtNext internal top color="black" url="desfemmes" />
        </section>
    );
};
export default NosChiffresCles;
